/**
 * @fileoverview POST handler for the "/apps/:app_group_id/encryption_settings" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { appsAppGroupIdEncryptionSettingsCacheKeys } from "./constants";
import type { PostAppsAppGroupIdEncryptionSettingsProps, PostUserDataEncryptionSettingsResult } from "./types";

export const postUserDataEncryptionSettings = reactQueryMutationAdapter(
  appsAppGroupIdEncryptionSettingsCacheKeys,
  (props: PostAppsAppGroupIdEncryptionSettingsProps): Promise<PostUserDataEncryptionSettingsResult> => {
    return fetch(`/apps/${props.app_group_id}/encryption_settings`, "POST", props.data, undefined, {
      propagateFetchRequestError: false,
    });
  }
);
